"use client";

import { ChevronLeft, ChevronRight } from "lucide-react";
import { MagneticButton } from "@/components/buttons/MagneticButton";
import { Counter } from "./Counter";

interface SliderControlsProps {
  counterValue: string;
  onPrev: () => void;
  onNext: () => void;
}

export function SliderControls({
  counterValue,
  onPrev,
  onNext,
}: SliderControlsProps) {
  return (
    <div className="flex items-center gap-4" role="group" aria-label="Slider controls">
      <MagneticButton onClick={onPrev} aria-label="Previous collection">
        <ChevronLeft size={18} strokeWidth={2.4} />
      </MagneticButton>
      <Counter value={counterValue} />
      <MagneticButton onClick={onNext} aria-label="Next collection">
        <ChevronRight size={18} strokeWidth={2.4} />
      </MagneticButton>
    </div>
  );
}